<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <section class="modal-card-body">
          <div>
            <b-message type="is-info">
              <div>
                <p class="is-size-5 has-text-weight-bold mb-sm">
                  <span v-if="timesheets.length === 1">Approve Timesheet?</span>
                  <span v-else>Approve Timesheets?</span>
                </p>
                <p class="is-size-7">
                  When you approve timesheets, they will no longer be editable and will
                  will be summarized in their respective billing period.
                </p>
              </div>
            </b-message>
          </div>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button
            type="is-primary"
            native-type="submit"
            :loading="saving"
            :disabled="saving">
            <span v-if="timesheets.length === 1">Approve Timesheet</span>
            <span v-else>Approve Timesheets</span>
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['api', 'context']),
    timesheets () {
      const timesheets = []
      this.seats.forEach(seat => {
        if (seat.timesheets.length === 1) {
          timesheets.push(seat.timesheets[0])
        }
      })
      return timesheets
    }
  },
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/projects/' + this.project.id + '/timesheets/approve'
      const json = {
        timesheets: []
      }
      this.timesheets.forEach(timesheet => {
        json.timesheets.push({ id: timesheet.id })
      })
      this.$http.put(endpoint, json).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Timesheets updated!' })
        this.$parent.close()
        this.$emit('project:saved')
      })
    }
  },
  props: {
    project: {
      type: Object
    },
    seats: {
      type: Array,
      required: true
    }
  }
}
</script>
